export default __webpack_public_path__ + "static/media/featured_area_london.112e243b.webp";